import React, { Component } from 'react'
import './stylesheets/headerback.css';
import constant from '../../../configs/constant';
import Auth from '../../../modules/Auth';
import { Navbar, Nav, Container, NavItem } from 'react-bootstrap';
import { NavLink  } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AiFillHome,AiOutlineLogout } from "react-icons/ai";

export default class HeaderBack extends Component {
  constructor(props) {
    super(props);
    const accesstokendata =  localStorage.getItem('access_token');
    const readData = JSON.parse(accesstokendata);
    // const display_name =  readData.userdata.display_name;
    const display_name ='HO';
    var currentPath = window.location.pathname;
    this.state = {
      scope: "Services",
      headerapp:'Approvals',
      display_name:display_name,
      currentPath:currentPath
    }
  }
  
  componentDidMount() {
    // const permissionsdata =  localStorage.getItem('permissions');
    // const permissionsreadData = JSON.parse(permissionsdata);
    // const filteredData = permissionsreadData.filter(obj => {
    //   return obj.PermissionCode === 'VALIDATE_JOB' || obj.PermissionCode === 'AUTHORIZE_JOB';
    // });
    // if(filteredData.length > 0){
    //   if(filteredData[0].PermissionCode === 'VALIDATE_JOB'){
    //     this.setState({
    //       headerapp: 'Validate',
    //     });
    //   }else if(filteredData[0].PermissionCode === 'AUTHORIZE_JOB'){
    //     this.setState({
    //       headerapp: 'Approvals',
    //     });
    //   }
    // }else{

    // }
    window.scrollTo(0, 0);
  }

  handleInNewTab = event =>{
    var url = 'https://thejoengineering-my.sharepoint.com/:b:/g/personal/itcorp_thejo-engg_com/Eade7YbgjDhAhcHIgT2FPgYB3dbAZohmTEqgXqdwqrV8sQ?e=amL3Lo';
    console.log();
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  handleChange = event => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to logout?",
      icon: 'warning',
      showCancelButton: true,
      allowOutsideClick:false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'No',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        Auth.logout();
      }
    })
  }

  render() {
    const logocompany = require('../../../assets/images/Thejo Splice logofive.png');
    const spliceLogo = require('../../../assets/images/Name.png');
    const homeLogo = require('../../../assets/images/home2.png');
    const homeBlueLogo = require('../../../assets/images/homeblue.png');
    const logoutLogo = require('../../../assets/images/logout.png');
    const helpLogo = require('../../../assets/images/help.png');
    return (
      <header className="header-back container">
        <Navbar bg="light" className="back-nav">
            <Navbar.Brand href="#home"><NavLink  className="nav-link text-end" to="/pm-schedule"><img src={logocompany}
                             alt="logo" className="logo-header-back"/></NavLink ></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="navData">
              <NavLink   className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/' title="Home"><img src={this.state.currentPath === '/' ? homeBlueLogo : homeLogo}
                             alt="logo" className="logo-header-home"/></NavLink>
                <NavLink  className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/change-password'>Change Password</NavLink>
                <NavLink  className={({ isActive }) => (isActive ? "active-menu nav-link font_size" : "nav-link nav-link-data font_size")} to='/licence'>Licenses</NavLink>
                <NavItem  className="nav-link cursorClass font_size" onClick={this.handleChange} title="Logout"><img src={logoutLogo}
                             alt="logo" className="logo-header-logout"/></NavItem>
              </Nav>
              <Nav className="me-auto2">
                <span className="diplay_name ml-auto">{this.state.display_name}</span>
                {/* <span className="header_name_data"><b><img src={spliceLogo}alt="logo" className="icon-header"/></b></span> */}
                <span className="verClassother">{constant.appVersions}</span>
              </Nav>
            </Navbar.Collapse>
        </Navbar>
    </header>
    )
  }
}





